import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {Loading} from "../Loading";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {ColumnHeader} from "./column_header/ColumnHeader";
import {ColumnSensitivityPopover} from "./column_header/ColumnSensitivityPopover";
import {showsColumnSensitivityFor} from "./column_header/columnsWithSemaphore";
import {DashboardItemsOrdering} from "./DashboardItemsOrdering";
import {SORT_DOWN, SORT_UP} from "../../utils/Array.extensions";
import {
    AGENCY_FLEX_INDICATOR,
    BUSINESS_UNIT_COLUMN,
    INDICATORS_COLUMNS,
    LABELS_COLUMN,
    getColumnHeaderInformation,
    getColumnData,
    setCustomMetricLabelsCache
} from "./columns";
import {DashboardHeader} from "./DashboardHeader";
import {DashboardConfig} from "../../utils/DashboardConfig";
import {clearColumnsUrlParam} from "../../utils/DashboardColumnsUrlParams";
import {RowWithErrorHandler} from "./rows/RowWithErrorHandler";
import DashboardRow from "./rows/DashboardRow";
import {ColumnSetPortalImpactModal} from "./ColumnSetPortalImpactModal";
import {Alert} from "reactstrap";
import {ColumnWithOrdering} from "./ColumnWithOrdering";
import {LocalStorage} from "../../utils/LocalStorage";
import {AddBusinessUnitModal} from "../client/AddBusinessUnitModal";
import {PrimaryButton} from "../buttons/PrimaryButton";
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import {setCustomMetricsEnabled} from "../../utils/FeatureFlags";
import {anchorAttr} from "../../guides/anchors";
import {UncontrolledSummaryCard} from "../alerts_center/uncontrolled/UncontrolledSummaryCard";

export class DashboardClass extends Component {
    constructor(props) {
        super(props);
        this._dashboardConfig = new DashboardConfig();
        this.state = {
            loaded: false,
            // `dashboard/basic-data` falló: no hay lista de líneas, así que no hay Tablero que
            // dibujar. Necesita estado propio porque `businessUnits: []` NO alcanza para
            // distinguir "no pude traerlas" de "esta agencia no tiene ninguna" — y hasta hoy se
            // confundían: tras aceptar el cartel, el Tablero mostraba el mensaje de bienvenida
            // ("Empezá a monitorear presupuestos y objetivos", con el botón de crear una línea)
            // a agencias con decenas de líneas cargadas.
            basicDataError: null,
            businessUnits: [],
            businessUnitRowsData: {},
            columnOrdering: this.getInitialOrdering(),
            activeColumns: [],
            activeColumnsSetId: null, // ID del set de columnas activo
            columnsSets: [],
            filters: {
                textFilter: this._dashboardConfig.getTextFilter(),
                issuesOnly: this._dashboardConfig.getIssuesOnlyFilter(),
                labelsFilter: this._dashboardConfig.getLabelsFilter(),
                platformFilter: this._dashboardConfig.getPlatformFilter(),
            },
            isDownloading: false,
            flexIndicators: null,
            ga4Indicators: null,
            ecommerceIndicators: null,
            paidMediaIndicators: null,
            metaIndicators: null,
            googleIndicators: null,
            tiktokIndicators: null,
            canEditFlexIndicators: false,
            moduleInsightsEnabled: false,
            bulkUserBusinessUnitsSyncEnabled: false,
            refreshKey: 0, // Key para forzar re-render de las filas

            // Resizing States
            isResizing: false,
            resizingStartX: 0,
            resizingStartWidth: 0,
            resizingCurrentTh: null,
            resizingTableWidth: window.innerWidth-72, // Track table width here

            showingEventualOutOfPeriodBusinessUnits: false,

            // Portal V2 (2026-05-28): modal de impacto cuando el set tiene assignments
            // a portales de cliente. Se abre desde handleSaveColumnSet / handleDeleteColumnSet
            // cuando el backend responde 409 con `requires_confirmation`.
            portalImpactModal: null, // {operation, setName, assignmentsCount, assignedClients, retry}
        };


        this._dashboardItems = new DashboardItemsOrdering();
        this.thRefs = {}; // Using an object to store refs for each column by `columnId`
        this.tableRef = React.createRef(); // Add ref for the table element
        //FEDE: Lo comento porque no lo hice funcionar
        //this.customWidthByColumnId = this.customWidthByColumnIdFromLocalStorage();

        this.handleTextFilterChange = this.handleTextFilterChange.bind(this);
        this.handleToggleIssuesOnly = this.handleToggleIssuesOnly.bind(this);
        this.handleLabelsFilterChange = this.handleLabelsFilterChange.bind(this);
        this.handleOrderingChange = this.handleOrderingChange.bind(this);
        this.handleBusinessUnitDataFetched = this.handleBusinessUnitDataFetched.bind(this);
        this.handleColumnStateChange = this.handleColumnStateChange.bind(this);
        this.handleColumnsPositionChange = this.handleColumnsPositionChange.bind(this);
        this.handleSaveColumnSet = this.handleSaveColumnSet.bind(this);
        this.handleApplyColumnSet = this.handleApplyColumnSet.bind(this);
        this.handleDeleteColumnSet = this.handleDeleteColumnSet.bind(this);
        this.handleLabelsChange = this.handleLabelsChange.bind(this);
        this.handleColumnColorChanged = this.handleColumnColorChanged.bind(this);
        this.handleSnoozeAllAlerts = this.handleSnoozeAllAlerts.bind(this);
        this.handleStopSnoozeForAllAlerts = this.handleStopSnoozeForAllAlerts.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handlePlatformFilterChange = this.handlePlatformFilterChange.bind(this);
        this.setColumnsSets = this.setColumnsSets.bind(this);
        this.setActiveColumns = this.setActiveColumns.bind(this);
        this.handleAfterSuccessfulBusinessUnitSubmit = this.handleAfterSuccessfulBusinessUnitSubmit.bind(this);
        this.handleGoToMyClients = this.handleGoToMyClients.bind(this);
        this.handleDownloadPromise = this.handleDownloadPromise.bind(this);
        this.handleSyncAllBusinessUnits = this.handleSyncAllBusinessUnits.bind(this);
        this.handleRetryBasicData = this.handleRetryBasicData.bind(this);
        this.getBasicDataAndConfigurateColumns = this.getBasicDataAndConfigurateColumns.bind(this);

    }

    // customWidthByColumnIdFromLocalStorage() {
    //     const columnWidths = JSON.parse(localStorage.getItem('columnWidths'));
    //     return (columnWidths) ? columnWidths : {};
    // }
    //
    // restoreColumnWidths() {
    //     // Obtén los anchos guardados de localStorage
    //     const columnWidths = JSON.parse(localStorage.getItem('columnWidths'));
    //     if (columnWidths) {
    //         // Itera sobre cada columna y aplica el ancho guardado
    //         Object.keys(columnWidths).forEach(columnId => {
    //             const th = this.thRefs[columnId];
    //             if (th) {
    //                 th.style.width = `${columnWidths[columnId]}px`;
    //             }
    //         });
    //     }
    // }

    getInitialOrdering() {
        const columnOrderingSaved = this.getSavedColumnOrdering();
        if(columnOrderingSaved !== null)
            return columnOrderingSaved;

        return DashboardItemsOrdering.defaultOrdering();
    }

    getSavedColumnOrdering() {
        const columnOrderingSaved = this._dashboardConfig.getColumnOrdering();

        if (columnOrderingSaved !== null) {
            const columnOrdering = JSON.parse(columnOrderingSaved)
            return new ColumnWithOrdering(columnOrdering['columnId'], columnOrdering['orderingDirection'])
        }

        return null;
    }

    componentDidMount() {
        this.getBasicDataAndConfigurateColumns();

        // Add mousemove and mouseup listeners
        document.addEventListener('mousemove', this.resizeColumn);
        document.addEventListener('mouseup', this.stopResize);

        // Set the initial table width
        if (this.tableRef.current) {
            const initialTableWidth = Math.max(this.tableRef.current.offsetWidth, window.innerWidth);
            this.setState({resizingTableWidth: initialTableWidth});
        }

        // FEDE: Lo comento porque no lo hice funcionar
        //this.restoreColumnWidths();
    }

    componentWillUnmount() {
        // Cleanup event listeners when component is unmounted
        document.removeEventListener('mousemove', this.resizeColumn);
        document.removeEventListener('mouseup', this.stopResize);
    }

    initResize = (e, columnId) => {
        const th = this.thRefs[columnId];
        if (!th) return;

        // Guardo el tamaño inicial de la tabla aquí
        const initialTableWidth = this.tableRef.current ? this.tableRef.current.offsetWidth : window.innerWidth;


        this.setState({
            isResizing: true,
            resizingStartX: e.pageX,
            resizingStartWidth: th.offsetWidth,
            resizingCurrentTh: th,
            resizingInitialTableWidth: initialTableWidth, // Almacena el ancho inicial de la tabla
        });
    };

    resizeColumn = (e) => {
        const { isResizing, resizingStartX, resizingStartWidth, resizingCurrentTh } = this.state;
        if (!isResizing || !resizingCurrentTh) return;

        const diffX = e.pageX - resizingStartX;
        const newThWidth = resizingStartWidth + diffX;

        // Update the width of the column being resized
        resizingCurrentTh.style.width = `${newThWidth}px`;

        // El nuevo ancho de la tabla se calcula sumando diffX al ancho inicial de la tabla
        const newTableWidth = Math.max(this.state.resizingInitialTableWidth + diffX, window.innerWidth); // Asegúrate de que no sea más pequeño que el ancho de la ventana

        this.tableRef.current.style.width = `${newTableWidth}px`;

        // Guarda el nuevo ancho de la columna en localStorage
        // FEDE: Lo comento porque no lo hice funcionar
        //this.saveColumnWidth(resizingCurrentTh.dataset.columnId, newThWidth);

        // Update state with the new table width
        this.setState({ resizingTableWidth: newTableWidth });
    };

    saveColumnWidth = (columnId, width) => {
        console.log(`Se guarda la columna ${columnId} con width ${width}`);
        LocalStorage.saveColumnWidth(columnId, width);
    };

    stopResize = () => {
        this.setState({
            isResizing: false,
            currentTh: null,
        });
    };

    setActiveColumns(columnsSetData) {
        // Nos quedamos con las que son validas
        const activeColumns = columnsSetData.columns.filter((columnId) => { return this.isValidColumnId(columnId); });

        this.setState({
            activeColumns: activeColumns,
            activeColumnsSetId: columnsSetData.id
        });
        this.setState((prevState) => {
            return {columnsSets: {...prevState.columnsSets, [columnsSetData.id]: columnsSetData}}
        });

        // Si hay columnas compartidas via URL, aplicarlas después de la configuración default
        this._applySharedColumnsIfPresent();
    }

    _applySharedColumnsIfPresent() {
        const sharedColumns = this.props.sharedColumns;
        if (!sharedColumns || sharedColumns.length === 0) return;

        const validColumns = sharedColumns.filter((columnId) => this.isValidColumnId(columnId));
        if (validColumns.length === 0) return;

        this.setState({
            activeColumns: validColumns,
            activeColumnsSetId: null
        });
        this._dashboardConfig.saveActiveColumns(validColumns);
        clearColumnsUrlParam();
    }

    setColumnsSets(columnsSets) {
        this.setState({columnsSets: columnsSets});
    }

    // api

    handleRetryBasicData() {
        // Vuelve al loader: sin eso, reintentar no se ve — la pantalla de error se queda igual
        // hasta que responda el request, y el usuario vuelve a clickear.
        this.setState({loaded: false, basicDataError: null}, this.getBasicDataAndConfigurateColumns);
    }

    getBasicDataAndConfigurateColumns() {
        new APIClient(API_URL + 'dashboard/basic-data').call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({basicDataError: null});
                    this._addOrderingValuesForFirstColumn(response.data.business_units);
                    setCustomMetricsEnabled(response.data.custom_metrics_enabled === true);
                    // Hidratar cache de display_names de custom metrics para que
                    // las columnas FlexIndicator con CUSTOM:<id> muestren label
                    // amigable en V1, V2 y el header del dashboard (sin esto sale
                    // "CUSTOM:5" raw).
                    setCustomMetricLabelsCache(response.data.custom_metrics);
                    this._setBusinessUnitsAndIndicatorsAndSetLoadedAndConfigureColumns(response.data.business_units, response.data.flex_indicators_indicators, response.data.ga4_indicators, response.data.ecommerce_indicators, response.data.paid_media_indicators, response.data.meta_indicators, response.data.google_indicators, response.data.tiktok_indicators, response.data.can_edit_flex_indicators, response.data.module_insights_enabled, response.data.bulk_user_business_units_sync_enabled, response.data.custom_metrics, response.data.custom_metric_indicators);

                } else if (this._hasBusinessUnitsToShow()) {
                    // Ya hay líneas dibujadas: esto es un REFRESCO que falló, no la carga. La
                    // pantalla de error borraría de golpe las 18 filas que el usuario está
                    // mirando, por un blip — peor que el `alert()` que había antes, que se
                    // aceptaba y dejaba el Tablero en su lugar. Pasa de verdad: «Sincronizar
                    // todas» reprograma este mismo fetch a los 3 s.
                    const { t } = this.props;
                    toast.error(t('dashboard.refresh_error'));
                } else {
                    // No hay nada que mostrar, así que la pantalla de error no tapa nada.
                    // `error_message` puede venir vacío (un 500 sin JSON cae al genérico del
                    // APIClient): el render tiene su propio texto.
                    this.setState({loaded: true, basicDataError: response.error_message || ''});
                }
            });
    }

    // event handlers

    handleAfterSuccessfulBusinessUnitSubmit(businessUnitId) {
        this.props.history.push(`/business-unit/${businessUnitId}/accounts?showAddAccountModal=true`);
    }

    handleGoToMyClients() {
        const loggedUserId = LocalStorage.fetchUserId();
        this.props.history.push(`/user/${loggedUserId}/module/marketing`);
    }

    handleLabelsChange(businessUnitId, labels) {
        const businessUnits = this.state.businessUnits.map(businessUnitData => {
            if (businessUnitData.id === businessUnitId) {
                return {
                    ...businessUnitData,
                    labels: labels
                }
            } else {
                return businessUnitData
            }
        });
        this._setBusinessUnits(businessUnits);
    }

    // event handlers - filters and ordering

    handlePlatformFilterChange(platformValue) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, platformFilter: platformValue}}
        });
        this._dashboardConfig.savePlatformFilter(platformValue);

    }

    handleTextFilterChange(textInput) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, textFilter: textInput}}
        });
        this._dashboardConfig.saveTextFilter(textInput)
    }

    handleToggleIssuesOnly(isOn) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, issuesOnly: isOn}}
        });
        this._dashboardConfig.saveIssuesOnlyFilter(isOn)
    }

    handleLabelsFilterChange(selectedLabels) {
        this.setState((prevState) => {
            return {filters: {...prevState.filters, labelsFilter: selectedLabels}}
        });
        this._dashboardConfig.saveLabelsFilter(selectedLabels)
    }

    handleOrderingChange(columnOrdering) {
        this.setState({columnOrdering: columnOrdering});
        this._setBusinessUnits(this.state.businessUnits, columnOrdering);
        this._dashboardConfig.saveColumnOrdering(columnOrdering);
    }

    // event handlers - business unit rows data fetched

    handleBusinessUnitDataFetched(businessUnitId, businessUnitData) {
        if (!businessUnitData) {
            return;
        }
        const columns = Object.keys(businessUnitData);
        columns.forEach((column) => {
            const columnData = businessUnitData[column];
            const orderingValues = (columnData != null && typeof columnData === 'object') ? columnData.ordering_values : null;
            this._dashboardItems.addOrderingValues(businessUnitId, column,
                (orderingValues != null && Array.isArray(orderingValues)) ? orderingValues : [Number.MIN_SAFE_INTEGER]);
        });

        // Si tengo un orden guardado, aca lo implemento.
        // Se podria verificar de no cambiar nada si es el mismo orden que ya esta
        const columnOrderingSaved = this.getSavedColumnOrdering();

        if(columnOrderingSaved !== null) {
            const sortedBusinessUnits = this._getSortedBusinessUnit(columnOrderingSaved, this.state.businessUnits);
            this._setBusinessUnitRowsDataForAndBusinessUnits(businessUnitId, businessUnitData, sortedBusinessUnits)
        }
        else
            this._setBusinessUnitRowsDataFor(businessUnitId, businessUnitData);
    }

    // event handlers - download dashboard data

    handleDownload() {
        this.setIsDownloadingState(true);
        this.downloadDashboardData();
    }

    handleDownloadPromise(response) {
        if(response.status !== 'OK') {
            alert(response.error_message);
        }
        this.setIsDownloadingState(false)
    }

    downloadDashboardData() {
        let downloadUrl = this.urlForDownload();

        return new APIClient(downloadUrl).download('GET', this.defaultDashboardFilename(), this.handleDownloadPromise);
    }

    urlForDownload() {
        let columns = JSON.stringify(this.state.activeColumns);
        let filters = JSON.stringify(this.state.filters);

        return `${API_URL}dashboard/export-columns-data?columns=${columns}&filters=${filters}`
    }

    defaultDashboardFilename() {
        return `Dashboard-Data.csv`;
    }

    setIsDownloadingState(isDownloading) {
        this.setState({isDownloading: isDownloading});
    }

    handleSyncAllBusinessUnits(event) {
        if (event) {
            event.preventDefault();
        }
        new APIClient(API_URL + 'user/sync-all-business-units').call('POST')
            .then((response) => {
                if (response.status === 'OK') {
                    // Esperar 3 segundos antes de refrescar las líneas de control
                    // para dar tiempo al servidor de actualizar el estado a "actualizando"
                    setTimeout(() => {
                        this.getBasicDataAndConfigurateColumns();
                    }, 3000);
                } else {
                    alert(response.error_message);
                }
            });
            // .catch((error) => {
            //     alert(t('dashboard.sync_all_error'));
            // });
    }

    // helpers

    _setBusinessUnits(businessUnits, columnOrdering = null) {
        const sortedBusinessUnits = this._getSortedBusinessUnit(columnOrdering, businessUnits);
        this.setState({businessUnits: sortedBusinessUnits});
    }

    _getSortedBusinessUnit(columnOrdering, businessUnits) {
        if (columnOrdering === null) {
            columnOrdering = this.state.columnOrdering;
        }
        const sortedBusinessUnits = this._dashboardItems.sortByColumn(businessUnits, columnOrdering);
        return sortedBusinessUnits;
    }

    _setBusinessUnitsAndIndicatorsAndSetLoadedAndConfigureColumns(businessUnits, flexIndicators, ga4Indicators, ecommerceIndicators, paidMediaIndicators, metaIndicators, googleIndicators, tiktokIndicators, canEditFlexIndicators, moduleInsightsEnabled, bulkUserBusinessUnitsSyncEnabled, customMetrics, customMetricIndicators) {
        const sortedBusinessUnits = this._dashboardItems.sortByColumn(businessUnits, this.state.columnOrdering);
        this.setState({
            businessUnits: sortedBusinessUnits,
            businessUnitRowsData: {}, // Limpiar los datos de las filas para forzar recarga
            flexIndicators: flexIndicators,
            ga4Indicators: ga4Indicators,
            ecommerceIndicators: ecommerceIndicators,
            paidMediaIndicators: paidMediaIndicators,
            metaIndicators: metaIndicators,
            googleIndicators: googleIndicators,
            tiktokIndicators: tiktokIndicators,
            customMetrics: customMetrics || [],
            customMetricIndicators: customMetricIndicators || [],
            loaded:true,
            canEditFlexIndicators: canEditFlexIndicators,
            moduleInsightsEnabled: moduleInsightsEnabled,
            bulkUserBusinessUnitsSyncEnabled: bulkUserBusinessUnitsSyncEnabled || false,
            refreshKey: this.state.refreshKey + 1 // Incrementar la key para forzar re-render
        });

        this._dashboardConfig.retrieveDefaultConfiguration(this.setActiveColumns);
        this._dashboardConfig.retrieveColumnsSets(this.setColumnsSets);
    }

    _addOrderingValuesForFirstColumn(businessUnits) {
        function fullNameOfBu(businessUnitData) {
            return `${businessUnitData.client_name} | ${businessUnitData.name}`;
        }

        businessUnits.forEach((businessUnit) => {
            this._dashboardItems.addOrderingValues(businessUnit.id,
                BUSINESS_UNIT_COLUMN,
                [fullNameOfBu(businessUnit)]);
        });
    }

    // event handlers - columns position and state change

    handleColumnStateChange(changedColumnId, isVisible) {
        let activeColumns;
        if (isVisible) {
            activeColumns = this.state.activeColumns.concat(changedColumnId);
            // Si es una comparativa (FlexIndicator) recién creada desde el modal de
            // Configurar columnas, el catálogo `flexIndicators` (cargado una sola vez
            // en el mount vía dashboard/basic-data) todavía no la incluye, y
            // `isValidColumnId` la descartaría en el render → la columna no aparecía
            // hasta refrescar con F5. La registramos en el catálogo para que se
            // renderice al aplicar, sin requerir reload.
            if (changedColumnId.includes(AGENCY_FLEX_INDICATOR)) {
                this.setState((prevState) => {
                    const flexIndicators = prevState.flexIndicators || [];
                    if (flexIndicators.includes(changedColumnId)) return null;
                    return {flexIndicators: [...flexIndicators, changedColumnId]};
                });
            }
        } else {
            activeColumns = this.state.activeColumns.filter((columnId) =>
                columnId !== changedColumnId
            );
        }
        // Limpiar el ID del set activo cuando se cambian las columnas manualmente
        this.setState({activeColumns: activeColumns, activeColumnsSetId: null});
        this._dashboardConfig.saveActiveColumns(activeColumns);
    }

    handleColumnsPositionChange(activeColumnsInOrder) {
        // Limpiar el ID del set activo cuando se cambian las columnas manualmente
        this.setState({activeColumns: activeColumnsInOrder, activeColumnsSetId: null});
        this._dashboardConfig.saveActiveColumns(activeColumnsInOrder);
    }

    // event handlers - column sets

    _persistSavedSet(savedSet, setId, columnsToSave, setName) {
        const savedSetId = savedSet.id || setId;
        const savedSetName = savedSet.name || setName;
        const savedSetColumns = savedSet.columns || columnsToSave;

        this.setState((prevState) => {
            const newColumnsSets = {...prevState.columnsSets};
            const previousMetadata = newColumnsSets[savedSetId] || {};
            newColumnsSets[savedSetId] = {
                id: savedSetId,
                name: savedSetName,
                columns: savedSetColumns,
                // Preservamos la metadata de portal assignments si la teníamos cacheada;
                // el endpoint del save no la devuelve.
                portal_assignments_count: previousMetadata.portal_assignments_count || 0,
                assigned_client_ids: previousMetadata.assigned_client_ids || [],
            };
            return {
                columnsSets: newColumnsSets,
                activeColumns: savedSetColumns,
                activeColumnsSetId: savedSetId,
            };
        });

        this._dashboardConfig.applyColumnSet(savedSetId);
        return savedSet;
    }

    handleSaveColumnSet(setId, setName, columns, action = null) {
        // Portal V2: si el backend responde 409 (`requires_confirmation`), abrimos el modal
        // de impacto y dejamos que el user elija propagar / duplicar / cancelar. La
        // promise se resuelve con el resultado final del flow para que el caller
        // (ConfigColumnsModal) cierre / no cierre según corresponda.
        const { t } = this.props;
        const columnsToSave = columns || this.state.activeColumns;

        return this._dashboardConfig.saveColumnSet(setId, setName, columnsToSave, action)
            .then((response) => {
                if (response && response.requires_confirmation) {
                    return new Promise((resolve, reject) => {
                        this.setState({
                            portalImpactModal: {
                                operation: 'update',
                                setName,
                                assignmentsCount: response.assignments_count,
                                assignedClients: response.assigned_clients,
                                onChoose: (chosenAction) => {
                                    this.setState({ portalImpactModal: null });
                                    this.handleSaveColumnSet(setId, setName, columnsToSave, chosenAction)
                                        .then(resolve)
                                        .catch(reject);
                                },
                                onCancel: () => {
                                    this.setState({ portalImpactModal: null });
                                    reject({ status: 'CANCELLED' });
                                },
                            },
                        });
                    });
                }
                return this._persistSavedSet(response, setId, columnsToSave, setName);
            })
            .catch((error) => {
                if (error && error.status === 'CANCELLED') throw error;
                const errorMessage = error && error.errors && error.errors.length > 0
                    ? error.errors[0].message
                    : t('columns_sets_list.error_saving_column_set', 'Error al guardar el set de columnas');
                alert(errorMessage);
                throw error;
            });
    }

    handleApplyColumnSet(selectedSetId) {
        const set = this.state.columnsSets[selectedSetId];
        if (set && set.columns) {
            const validColumns = set.columns.filter((columnId) => this.isValidColumnId(columnId));
            this.setState({
                activeColumns: validColumns,
                activeColumnsSetId: selectedSetId // Actualizar el ID del set activo
            });
            // Usar set.id en lugar de selectedSetId para asegurar que se envíe el ID numérico
            const setId = set.id || selectedSetId;
            this._dashboardConfig.applyColumnSet(setId);
        }
    }

    _applyDeleteToState(setId) {
        const { t } = this.props;
        this.setState((prevState) => {
            const newColumnsSets = {...prevState.columnsSets};
            delete newColumnsSets[setId];
            const newActiveColumnsSetId = String(prevState.activeColumnsSetId) === String(setId)
                ? null
                : prevState.activeColumnsSetId;
            return {
                columnsSets: newColumnsSets,
                activeColumnsSetId: newActiveColumnsSetId,
            };
        });
        alert(t('columns_sets_list.column_set_deleted_successfully', 'Set de columnas borrado exitosamente'));
    }

    handleDeleteColumnSet(setId, action = null) {
        const { t } = this.props;
        const setName = this.state.columnsSets[setId] ? this.state.columnsSets[setId].name : '';

        // Sin action y sin assignments conocidos → preguntamos confirmación simple.
        // Si tiene assignments cacheados, saltamos al modal de impacto directo.
        const cached = this.state.columnsSets[setId];
        const cachedAssignments = cached && cached.portal_assignments_count ? cached.portal_assignments_count : 0;
        if (!action && cachedAssignments === 0) {
            if (!window.confirm(t('columns_sets_list.confirm_delete_column_set', '¿Está seguro de que desea borrar este set de columnas?'))) {
                return;
            }
        }

        this._dashboardConfig.deleteColumnSet(setId, action)
            .then((response) => {
                if (response && response.requires_confirmation) {
                    this.setState({
                        portalImpactModal: {
                            operation: 'delete',
                            setName,
                            assignmentsCount: response.assignments_count,
                            assignedClients: response.assigned_clients,
                            onChoose: (chosenAction) => {
                                this.setState({ portalImpactModal: null });
                                if (chosenAction === 'accept') {
                                    this.handleDeleteColumnSet(setId, 'accept');
                                }
                            },
                            onCancel: () => this.setState({ portalImpactModal: null }),
                        },
                    });
                    return;
                }
                this._applyDeleteToState(setId);
            })
            .catch((error) => {
                const errorMessage = error && error.errors && error.errors.length > 0
                    ? error.errors[0].message
                    : t('columns_sets_list.error_deleting_column_set', 'Error al borrar el set de columnas');
                alert(errorMessage);
            });
    }

    // event handlers - snoozed alerts

    handleSnoozeAllAlerts(businessUnitId, snoozeData) {
        this._setSnoozedStateForAllColumns(businessUnitId, true);
        this._setAlertsSnoozeFor(businessUnitId, {
            is_snoozed: true,
            snoozed_until: (snoozeData && snoozeData.snoozed_until) || null,
        });
    }

    handleStopSnoozeForAllAlerts(businessUnitId) {
        this._setSnoozedStateForAllColumns(businessUnitId, false);
        this._setAlertsSnoozeFor(businessUnitId, {is_snoozed: false, snoozed_until: null});
    }

    // El estado de la campanita vive en la fila básica (`alerts_snooze`), no en las columnas: es lo
    // que la fila lee para pintar la campana y decir hasta cuándo. Mismo patrón que `handleLabelsChange`.
    _setAlertsSnoozeFor(businessUnitId, alertsSnooze) {
        const businessUnits = this.state.businessUnits.map((businessUnitData) => (
            businessUnitData.id === businessUnitId
                ? {...businessUnitData, alerts_snooze: alertsSnooze}
                : businessUnitData
        ));
        this._setBusinessUnits(businessUnits);
    }

    _setSnoozedStateForAllColumns(businessUnitId, newState) {
        Object.keys(this.state.businessUnitRowsData).forEach((buId) => {
            if (this.state.businessUnitRowsData[buId].business_unit_id === businessUnitId) {
                let newBusinessUnit = this.state.businessUnitRowsData[buId];
                this.getIndicatorsColumns().forEach((column) => {
                    newBusinessUnit[column] = {
                        ...this.state.businessUnitRowsData[buId][column],
                        alert_snoozed: newState
                    };
                });
                this._setBusinessUnitRowsDataFor(buId, newBusinessUnit);
            }
        });
    }

    // helper methods

    _setBusinessUnitRowsDataFor(businessUnitId, businessUnitData) {
        this.setState((prevState) => {
            return {
                businessUnitRowsData: {
                    ...prevState.businessUnitRowsData,
                    [businessUnitId]: businessUnitData
                }
            }
        });
    }

    _setBusinessUnitRowsDataForAndBusinessUnits(businessUnitId, businessUnitData, businessUnits) {
        this.setState((prevState) => {
            return {
                businessUnitRowsData: {
                    ...prevState.businessUnitRowsData,
                    [businessUnitId]: businessUnitData
                },
                businessUnits: businessUnits
            }
        });
    }

    _rowDataFor(businessUnitId) {
        if (businessUnitId in this.state.businessUnitRowsData) {
            // console.log("Se supone que aca deberia tener los valores para las columnas y tengo");
            // console.log(this.state.businessUnitRowsData[businessUnitId]["FULL_PERIOD_ODS_COLUMN"]);
            return this.state.businessUnitRowsData[businessUnitId];
        } else
            return null;
    }


    // getColumnDefaultWidth(columnId) {
    //     if(this.customWidthByColumnId[columnId] !== undefined)
    //         return this.customWidthByColumnId[columnId];
    //
    //     return null;
    // }

    // rendering

    renderAddBusinessUnitButton(showText) {
        const { t } = this.props;
        return [
            <PrimaryButton onClick={(event) => {this.addBusinessUnitModal.toggle()}} icon="plus" text={t('dashboard.create_control_line')} showText={showText}/>,
            <AddBusinessUnitModal ref={instance => {this.addBusinessUnitModal = instance;}}
                                  afterSuccessfulSubmit={this.handleAfterSuccessfulBusinessUnitSubmit}
                                  history={this.props.history}
            />];
    }

    renderGoToMyClientsButton() {
        const { t } = this.props;
        return <PrimaryButton onClick={(event) => {this.handleGoToMyClients()}} icon="user" text={t('dashboard.assign_clients_to_me')} />;
    }

    render() {
        if (!this.state.loaded) {
            const { t } = this.props;
            return (
                <div className="app-content">
                    <LayoutSidebar/>
                    <section className="section-content">
                        <Loading message={t('common.loading')}/>
                    </section>
                </div>
            );
        }

        if (this.state.basicDataError !== null) {
            return this._renderBasicDataError();
        }

        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content dashboard">
                    <DashboardHeader
                        filters={this.state.filters}
                        onTextFilterChange={this.handleTextFilterChange}
                        onToggleIssuesOnly={this.handleToggleIssuesOnly}
                        onLabelsFilterChange={this.handleLabelsFilterChange}
                        activeColumns={this.state.activeColumns}
                        activeColumnsSetId={this.state.activeColumnsSetId}
                        handleColumnStateChange={this.handleColumnStateChange}
                        onColumnsPositionChange={this.handleColumnsPositionChange}
                        columnsSets={this.state.columnsSets}
                        onSelectColumnSet={this.handleApplyColumnSet}
                        onSaveColumnSet={this.handleSaveColumnSet}
                        onDeleteColumnSet={this.handleDeleteColumnSet}
                        onDownloadDashboardData={this.handleDownload}
                        isDownloading={this.state.isDownloading}
                        onPlatformFilterChange={this.handlePlatformFilterChange}
                        flexIndicators={this.state.flexIndicators}
                        ga4Indicators={this.state.ga4Indicators}
                        ecommerceIndicators={this.state.ecommerceIndicators}
                        paidMediaIndicators={this.state.paidMediaIndicators}
                        metaIndicators={this.state.metaIndicators}
                        googleIndicators={this.state.googleIndicators}
                        tiktokIndicators={this.state.tiktokIndicators}
                        customMetrics={this.state.customMetrics}
                        customMetricIndicators={this.state.customMetricIndicators}
                        canEditFlexIndicators={this.state.canEditFlexIndicators}
                        moduleInsightsEnabled={this.state.moduleInsightsEnabled}
                        bulkUserBusinessUnitsSyncEnabled={this.state.bulkUserBusinessUnitsSyncEnabled}
                        onSyncAllBusinessUnits={this.handleSyncAllBusinessUnits}
                    />
                    {/* «≈ ARS 513 mil sin control esta semana · En 4 cuentas · Ver →» (UD-5): un renglón gris que
                        lleva a la solapa «Inversión sin control». Fuera de `.table-box`, así no hereda su ancho ni
                        su scroll lateral. Se protege sola: sin el permiso o en el clásico no pide ni dibuja. */}
                    <UncontrolledSummaryCard className="-board"/>
                    <div className="section-body table-box -dashboard">
                        <table id="resizableTable"
                               className="table table-striped-manually"
                               ref={this.tableRef}  // Attach table ref here
                               style={{
                                   width: `${this.state.resizingTableWidth}px`,
                                   tableLayout: 'auto',
                                   minWidth: '100%'
                               }} // Fixed layout and min width 100%
                        >
                            <thead>
                            <tr>
                                {this._renderHeader()}
                            </tr>
                            </thead>
                            <tbody>
                            {this._renderDashboardRows()}
                            </tbody>
                        </table>
                    </div>
                </section>
                {this.state.portalImpactModal && (
                    <ColumnSetPortalImpactModal
                        isOpen={true}
                        toggle={this.state.portalImpactModal.onCancel}
                        operation={this.state.portalImpactModal.operation}
                        setName={this.state.portalImpactModal.setName}
                        assignmentsCount={this.state.portalImpactModal.assignmentsCount}
                        assignedClients={this.state.portalImpactModal.assignedClients}
                        onChoose={this.state.portalImpactModal.onChoose}
                    />
                )}
            </div>
        )
    }

    _renderHeader() {
        if(!this._hasBusinessUnitsToShow())
            return null;

        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);

        return (
            <React.Fragment>
                <ColumnHeader
                    key={BUSINESS_UNIT_COLUMN}
                    title={columnHeaderInfo[BUSINESS_UNIT_COLUMN]['title']}
                    columnId={BUSINESS_UNIT_COLUMN}
                    //FEDE: Lo comento porque no lo hice funcionar
                    //defaultWidth={this.getColumnDefaultWidth(BUSINESS_UNIT_COLUMN)}
                    isActive={this.state.columnOrdering.columnId() === BUSINESS_UNIT_COLUMN}
                    canBeSorted={true}
                    hasHelper={false}
                    defaultOrderingDirection={this.state.columnOrdering.columnId() === BUSINESS_UNIT_COLUMN ? this.state.columnOrdering.orderingDirection() : SORT_UP}
                    onSetOrdering={this.handleOrderingChange}
                    thRef={(el) => (this.thRefs[BUSINESS_UNIT_COLUMN] = el)} // Attach ref here
                    onInitResize={this.initResize} // Pass the resize function down
                    additionalButton={this.renderAddBusinessUnitButton(false)}
                    guideAnchor={anchorAttr('dashboard_lines_column')}
                />
                {this._renderColumnHeaders()}
            </React.Fragment>
        );
    }

    /**
     * Reemplaza al Tablero entero, no a una fila: sin `basic-data` no hay lista de líneas, así que
     * no hay nada que dibujar. Ocupa el lugar del mensaje de bienvenida —que es lo que se veía
     * antes— porque decirle "creá tu primera línea de control" a quien tiene veinte es peor que
     * no decir nada.
     */
    _renderBasicDataError() {
        const { t } = this.props;
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content dashboard">
                    <div className="dashboard-empty-message -as-screen">
                        <h1>{t('dashboard.load_error')}</h1>
                        <h2>{t('dashboard.load_error_explanation')}</h2>
                        <PrimaryButton onClick={this.handleRetryBasicData} icon="sync-alt" text={t('dashboard.load_error_retry')}/>
                    </div>
                </section>
            </div>
        );
    }

    _renderAlertNoBuAssigned() {
        const { t } = this.props;
        return <tr data-id="0">
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <div className="dashboard-empty-message">
                    <h1>{t('dashboard.start_monitoring_budgets_and_goals')}</h1>
                    <h2>{t('dashboard.you_can_create_clients_and_business_units')}</h2>
                    {this.renderAddBusinessUnitButton(true)}
                    {this.renderGoToMyClientsButton()}
                </div>
            </td>
        </tr>;
    }

    _renderEventualOutOfPeriodBusinessUnits(rowsToRender, rowsEventualOutOfPeriod) {
        const { t } = this.props;
        const toggleText = this.state.showingEventualOutOfPeriodBusinessUnits ? t('dashboard.hide') : t('dashboard.show');

        if(rowsEventualOutOfPeriod.length > 0) {
            rowsToRender.push(<tr data-id="0">
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning out-of-period-row">{t('dashboard.there_are_eventual_budgets', {count: rowsEventualOutOfPeriod.length})}<a onClick={() => {this.toggleEventualOutOfPeriodBusinessUnits()}} title={t('dashboard.can_deactivate_budgets')}>[{toggleText}]</a></Alert>
                </td>
            </tr>)

            if(this.state.showingEventualOutOfPeriodBusinessUnits) {
                rowsToRender.push(...rowsEventualOutOfPeriod);
            }
        }
    }

    _renderFilteringMessage(rowsToRender, totalRows, filteredRows) {
        const { t } = this.props;
        if(totalRows === filteredRows)
            return;

        // Sino imprimió ningún presupuesto decimos que es por los filtros
        if(filteredRows === 0) {
            rowsToRender.push(<tr data-id="0">
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning filtering-alert">{t('dashboard.no_business_units_found_with_filters')}<a onClick={() => {this.resetFilters()}}>[{t('dashboard.remove_filters')}]</a></Alert>
                </td>
            </tr>)
        } else {
            rowsToRender.push(<tr data-id="0" style={{position:"absolute", zIndex:1}}>
                <td colSpan={this._numberOfColumns()} className="row-loader">
                    <Alert className="alert-warning filtering-alert filtering-data">{t('dashboard.showing_business_units', {filtered: filteredRows, total: totalRows})}<a onClick={() => {this.resetFilters()}}>[{t('dashboard.remove_filters')}]</a></Alert>
                </td>
            </tr>)
        }
    }

    toggleEventualOutOfPeriodBusinessUnits() {
        this.setState({showingEventualOutOfPeriodBusinessUnits: !this.state.showingEventualOutOfPeriodBusinessUnits});
    }

    resetFilters() {
        this._dashboardConfig.resetFilters();

        this.setState({
            filters: {
                textFilter: "",
                issuesOnly: false,
                labelsFilter: [],
                platformFilter: "",
            }
        });
    }

    _numberOfColumns() {
        return (this.state.activeColumns.length+1);
    }

    _renderDashboardRows() {
        if (!this._hasBusinessUnitsToShow()) {
            return this._renderAlertNoBuAssigned()
        }

        // a cada fila se le manda el numero de fila que va a depender de si se esta filtrando o no
        let counter = 1
        const rows = [];
        const rowsEventualOutOfPeriod = [];
        // El recorrido del Tablero explica el nombre y el «+» de la PRIMERA línea de la tabla. Una
        // eventual fuera de período consume el contador pero se dibuja abajo: no es la primera.
        let guideRowAssigned = false;
        this.state.businessUnits.forEach((businessUnitData) => {
            const data = this._rowDataFor(businessUnitData.id);
            if (data === null || this.matchesFilters(businessUnitData, data)) {
                const hasAdAccountsDataToShow = (data !== null && data.more_than_one_campaigns_configuration);
                const isGuideRow = !guideRowAssigned && businessUnitData.is_eventual_out_of_period !== true;
                guideRowAssigned = guideRowAssigned || isGuideRow;
                const row = <RowWithErrorHandler key={`${businessUnitData.id}-${this.state.refreshKey}`}>
                    <DashboardRow
                        rowOrderNumber={counter}
                        guideRow={isGuideRow}
                        key={`${businessUnitData.id}-${this.state.refreshKey}`}
                        activeColumns={this.state.activeColumns}
                        filterValues={this.state.filters}
                        businessUnitId={businessUnitData.id}
                        businessUnitName={businessUnitData.name}
                        businessUnitType={businessUnitData.type}
                        budgetType={businessUnitData.budget_type}
                        businessUnitData={data}
                        syncInformation={businessUnitData.sync_information}
                        adAccountsData={businessUnitData.campaigns_configuration_rows}
                        hasAdAccountsDataToShow={hasAdAccountsDataToShow}
                        channels={businessUnitData.channels}
                        clientId={businessUnitData.client_id}
                        clientName={businessUnitData.client_name}
                        downUrlsCount={businessUnitData.down_urls_count}
                        hasUrls={businessUnitData.has_urls}
                        generalAlerts={businessUnitData.general_alerts}
                        alertsSnooze={businessUnitData.alerts_snooze}
                        currencyConversions={businessUnitData.currency_conversions}
                        businessUnitCurrency={businessUnitData.currency}
                        uncoveredSpend={businessUnitData.uncovered_spend}
                        businessUnitLabels={businessUnitData.labels}
                        onBusinessDataFetched={this.handleBusinessUnitDataFetched}
                        onSnoozeAllAlerts={this.handleSnoozeAllAlerts}
                        onStopSnoozeForAllAlerts={this.handleStopSnoozeForAllAlerts}
                        onLabelsChange={this.handleLabelsChange}
                        agencyFlexIndicators={this.state.flexIndicators}
                        ga4Indicators={this.state.ga4Indicators}
                        ecommerceIndicators={this.state.ecommerceIndicators}
                        paidMediaIndicators={this.state.paidMediaIndicators}
                        metaIndicators={this.state.metaIndicators}
                        googleIndicators={this.state.googleIndicators}
                        tiktokIndicators={this.state.tiktokIndicators}
                        customMetricIndicators={this.state.customMetricIndicators}
                        location={this.props.location}
                    />
                </RowWithErrorHandler>;

                if(businessUnitData.is_eventual_out_of_period === true) {
                    rowsEventualOutOfPeriod.push(row);
                } else {
                    rows.push(row);
                }
                counter += 1;
            }
        });

        this._renderEventualOutOfPeriodBusinessUnits(rows, rowsEventualOutOfPeriod);
        this._renderFilteringMessage(rows, this.state.businessUnits.length, counter-1);

        return rows;
    }

    _hasBusinessUnitsToShow() {
        return this.state.businessUnits.length > 0;
    }

    isValidColumnId(columnId) {
        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);
        return columnId in columnHeaderInfo
            || (this.state.flexIndicators != null && this.state.flexIndicators.includes(columnId))
            || (this.state.ga4Indicators != null && this.state.ga4Indicators.includes(columnId))
            || (this.state.ecommerceIndicators != null && this.state.ecommerceIndicators.includes(columnId))
            || (this.state.paidMediaIndicators != null && this.state.paidMediaIndicators.includes(columnId))
            || (this.state.metaIndicators != null && this.state.metaIndicators.includes(columnId))
            || (this.state.googleIndicators != null && this.state.googleIndicators.includes(columnId))
            || (this.state.tiktokIndicators != null && this.state.tiktokIndicators.includes(columnId))
            || (this.state.customMetricIndicators != null && this.state.customMetricIndicators.includes(columnId));
    }

    _renderColumnHeaders() {
        const { t } = this.props;
        return this.state.activeColumns.map((columnId) => {
            if(!this.isValidColumnId(columnId)) {
                return null;
            }

            const columnData = getColumnData(t, columnId);

            return <ColumnHeader
                key={columnId}
                title={columnData['title']}
                subtitle={columnData['subtitle']}
                helper={columnData['helper']}
                additionalButton={this._columnSensitivityButtonFor(columnId)}
                columnId={columnId}
                //FEDE: Lo comento porque no lo hice funcionar
                //defaultWidth={this.getColumnDefaultWidth(columnId)}
                isActive={this.state.columnOrdering.columnId() === columnId}
                canBeSorted={this._canBeSorted(columnId)}
                hasHelper={true}
                defaultOrderingDirection={this.state.columnOrdering.columnId() === columnId? this.state.columnOrdering.orderingDirection() : SORT_DOWN}
                onSetOrdering={this.handleOrderingChange}
                thRef={(el) => (this.thRefs[columnId] = el)} // Attach ref here
                onInitResize={this.initResize} // Pass the resize function down
            />
        });
    }

    _columnSensitivityButtonFor(columnId) {
        // `undefined` a propósito y no `null`: `ColumnTitle` monta un `<span>` con margen para
        // cualquier valor definido, y ese margen correría el título de TODOS los encabezados
        // del Dashbo clásico, que tiene que quedar igual que siempre.
        if (!showsColumnSensitivityFor(this.props.showsColumnSensitivity, columnId)) {
            return undefined;
        }
        return <ColumnSensitivityPopover columnId={columnId} onColorChanged={this.handleColumnColorChanged}/>;
    }

    handleColumnColorChanged() {
        // El color de cada celda viaja DENTRO del payload de su fila, y cada fila lo pide una
        // sola vez al montarse. Sin esto el usuario mueve el switch, ve moverse el switch, y
        // las celdas siguen exactamente igual hasta que recarga la página: se lee como que la
        // opción no anda. `refreshKey` es el mecanismo que el Tablero ya usa para eso —
        // participa de la `key` de cada fila, así que remontarlas las hace pedir de nuevo.
        this.setState({refreshKey: this.state.refreshKey + 1});
    }

    _canBeSorted(columnId) {
        return columnId !== LABELS_COLUMN;
    }

    /*
    * Lo que sigue estaba en FilterableDashboardRow pero lo subí a este nivel porque necesito mandar el nro de fila
    *  para entender si se debe imprimir gris o blanco.
    *  Esto se hacía desde css con .table-striped tbody tr:nth-of-type(odd) pero en este caso no se puede porque las
    *  filas de los buccs tienen que estar en el mismo color que el bu
    * */
    matchesByTextFilter(businessUnitData) {
        if (this.state.filters.textFilter !== '') {
            const searchString = this.state.filters.textFilter.toLowerCase().trim().match(/(".*?"|\S+)/g) || [];
            const wordsToInclude = searchString.map(text => {
                if (text.startsWith('"') && text.endsWith('"')) {
                    // If keyword is a phrase between double quotes
                    return text.slice(1, -1);
                } else {
                    return text;
                }
            });

            const unionOfAllRowTexts = (businessUnitData.name + businessUnitData.client_name + this._getAdAccountNamesAndIdsText(businessUnitData)).toLowerCase();

            return wordsToInclude.every(keyword => {
                    return unionOfAllRowTexts.includes(keyword.toLowerCase());
            });
        } else {
            return true;
        }
    }

    _getAdAccountNamesAndIdsText(businessUnitData) {
        if (businessUnitData['campaigns_configuration_rows'] === undefined || businessUnitData['campaigns_configuration_rows'] === null)
            return "";

        let textToReturn = "";
        businessUnitData['campaigns_configuration_rows'].forEach((adAccountData) => {
            textToReturn += " " + adAccountData['name'] + " " + adAccountData['account_id'].toString()
        });

        return textToReturn;
    }

    matchesByLabelsFilter(businessUnitData) {
        if (this.state.filters.labelsFilter.length > 0) {
            return this.state.filters.labelsFilter.every((selectedLabel) =>
                businessUnitData.labels.includes(selectedLabel)
            );
        } else {
            return true;
        }
    }

    getIndicatorsColumns() {
        const flexIndicators = this.state.flexIndicators || [];
        const ga4Indicators = this.state.ga4Indicators || [];
        const ecommerceIndicators = this.state.ecommerceIndicators || [];
        const paidMediaIndicators = this.state.paidMediaIndicators || [];
        const metaIndicators = this.state.metaIndicators || [];
        const googleIndicators = this.state.googleIndicators || [];
        const tiktokIndicators = this.state.tiktokIndicators || [];
        return [...INDICATORS_COLUMNS, ...flexIndicators, ...ga4Indicators, ...ecommerceIndicators, ...paidMediaIndicators, ...metaIndicators, ...googleIndicators, ...tiktokIndicators];
    }

    matchesByHasIssuesFilter(businessUnitData, data) {
        if (this.state.filters.issuesOnly) {
            const hasDownUrls = businessUnitData.down_urls_count > 0;
            const hasAnIssueAndIsNotSnoozed = this.state.activeColumns.some((column) =>
                this.getIndicatorsColumns().includes(column) && data[column]?.has_issues && !data[column]?.alert_snoozed
            );
            const hasGeneralAlert = businessUnitData.general_alerts.has_no_access_alert || businessUnitData.general_alerts.has_no_impression_alert || businessUnitData.general_alerts.has_campaigns_not_assigned_alert;
            return hasDownUrls || hasAnIssueAndIsNotSnoozed || hasGeneralAlert || this._hasAccountStatusIssue(businessUnitData);
        } else {
            return true;
        }
    }

    // Estados por cuenta (`account_status`): una línea con una cuenta sin conexión o con datos
    // no actualizados tiene un problema aunque las alertas BU-level no lo reflejen.
    _hasAccountStatusIssue(businessUnitData) {
        const rows = businessUnitData.campaigns_configuration_rows;
        if (!Array.isArray(rows))
            return false;

        return rows.some((row) => row && row.account_status &&
            (row.account_status.connection || row.account_status.data_stale));
    }

    matchesByHasPlatformFilter(businessUnitData) {
        if (this.state.filters.platformFilter !== '') {
            const platformValue = this.state.filters.platformFilter.toUpperCase();
            return businessUnitData.channels.includes(platformValue);
        } else {
            return true;
        }

    }

    matchesFilters(businessUnitData, data) {
        return this.matchesByTextFilter(businessUnitData) &&
            this.matchesByLabelsFilter(businessUnitData) &&
            this.matchesByHasIssuesFilter(businessUnitData, data) &&
            this.matchesByHasPlatformFilter(businessUnitData);
    }

    /*
    Lo de FilterableDashboardRow llega hasta acá
    * */
}

export const Dashboard = withTranslation()(DashboardClass);
export default Dashboard;